/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Sign_InInputs */



/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Marketing_Sign_InInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const marketing_sign_in = /** @type {((inputs?: Marketing_Sign_InInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Sign_InInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Sign in")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Logga in")
	return /** @type {LocalizedString} */ ("Logg inn")
});